import script from "./DetalleDescargas.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalleDescargas.vue?vue&type=script&setup=true&lang=js"

import "./DetalleDescargas.vue?vue&type=style&index=0&id=4edc4a68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4edc4a68"]])

export default __exports__